import { render, staticRenderFns } from "./MarketplacePage.vue?vue&type=template&id=9571ec4c"
import script from "./MarketplacePage.vue?vue&type=script&lang=js"
export * from "./MarketplacePage.vue?vue&type=script&lang=js"
import style0 from "./MarketplacePage.vue?vue&type=style&index=0&id=9571ec4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports